// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileDoneOutlinedSvg from "@ant-design/icons-svg/es/asn/FileDoneOutlined";
import AntdIcon from '../components/AntdIcon';

var FileDoneOutlined = function FileDoneOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileDoneOutlinedSvg
  }));
};

FileDoneOutlined.displayName = 'FileDoneOutlined';
export default React.forwardRef(FileDoneOutlined);